import React from 'react';
import Typography from '@material-ui/core/Typography';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
const useStyles = makeStyles((theme) => ({
    clickableBC: {
        cursor: 'pointer',
        '&:hover': {
            textDecoration: 'underline',
            color: '#007bff'
        }
    },
    heading: {
        fontSize: '1.25rem',
        fontWeight: 'bold'
    }
}));
function handleClick(event) {
    event.preventDefault();
    // console.info('You clicked a breadcrumb.');
}

export default function Breadcrumb({ items, style, onClick, isClickable, isHeading }) {
    const classes = useStyles();

    const breadCrumbStyle = {
        marginTop: 10,
        paddingBottom: 10,
        ...(style || {})
    }



    const handleClick = (id) => {
        alert(id)
    }

    return (
        <>
            <Breadcrumbs aria-label="breadcrumb" id="bcrumb" separator={`${items?.filter(item=> item?.label !== "")?.length>1 ? '>' : ''}`} style={breadCrumbStyle}>
                {items.map((item, index) => {

                    return (
                        <Grid key={index}>
                            { !isHeading && !isClickable && item.url == null && <Typography color="textPrimary" key={index}>{item.label}</Typography>}
                            {item.url != null && <Link color="inherit" href="#" onClick={e => handleClick(item.url)} key={index}>{item.label}</Link>}
                            {isClickable === true && <Typography className={classes.clickableBC} color="textPrimary" onClick={() => onClick(item)} key={index}>{item.label}</Typography>}
                            {isHeading === true && <Typography className={classes.heading} color="textPrimary" key={index}>{item.label}</Typography>}
                        </Grid>
                    )
                })}
            </Breadcrumbs>

        </>
    )
}
